import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { Collapse, List, ListItemButton, ListItemSecondaryAction, ListItemText } from '@mui/material'
import React, { useState } from 'react'
import SubRubroCatalogo from './SubRubroCatalogo'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

export const DrawerItemsCatalogo = (params) => {
    // Extraer datos del estado global
    const { isLoggedIn } = useSelector(state => state.account)
    const { setCategorias, setDrawerOpen, categorias, label } = params

    // Estado para controlar el colapso de subcategorías
    const [collapseOpen, setCollapseOpen] = useState(false)

    // Navegación con React Router
    const navigate = useNavigate()

    // Función que maneja el clic en un item de la lista
    const handleItemClick = () => {
        // Cerrar el drawer
        setDrawerOpen(false)

        // Establecer las categorías según la etiqueta seleccionada
        if (label === "Destacados" || label === "Lanzamientos") {
            setCategorias("", "", "", label)
        } else {
            setCategorias(label === "Todos los productos" ? "" : label)
        }

        // Redirigir a la ruta correspondiente
        if (label === "Todos los productos" || label === "Lanzamientos" || label === "Destacados") {
            navigate(isLoggedIn ? "/products" : "/catalogo")
        } else {
            navigate(`/categoria/${label}`)
        }
    }

    // Función que maneja el clic en el botón de expansión
    const handleCollapseToggle = () => {
        setCollapseOpen(!collapseOpen)
    }

    return (
        <>
            <List component="div">
                {/* Item de la lista principal */}
                <ListItemButton onClick={handleItemClick}>
                    <ListItemText
                        primary={label}
                        primaryTypographyProps={{ fontSize: "15px", fontWeight: "600" }}
                    />
                </ListItemButton>

                {/* Mostrar el botón de expansión si hay subcategorías */}
                {categorias[label] && (
                    <ListItemSecondaryAction>
                        <ListItemButton onClick={handleCollapseToggle}>
                            {collapseOpen ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                        </ListItemButton>
                    </ListItemSecondaryAction>
                )}
            </List>

            {/* Colapsar las subcategorías si está abierto */}
            <Collapse in={collapseOpen} timeout="auto" unmountOnExit>
                {categorias[label] && Object.keys(categorias[label]).map((categoria, i) => (
                    <div key={`${categoria}-${i}`}>
                        <SubRubroCatalogo
                            rubro={categoria}
                            categorias={categorias}
                            label={label}
                            setCategorias={setCategorias}
                            setDrawerOpen={setDrawerOpen}
                        />
                    </div>
                ))}
            </Collapse>
        </>
    )
}
